import React from 'react';
import InfoTip from '../InfoTip';
import { EffortTrendPoint } from './types';
import * as fmt from '../../lib/format';

// Month by month: how many entries had one standard tag. The month on screen is the dark bar; the
// share is also written above each bar and in the summary read out by screen readers.
export default function TrendStrip({ points, current }: { points: EffortTrendPoint[]; current: string }) {
  if (points.length < 2) return null;
  const summary = points.map((p) => `${fmt.month(p.period)} ${fmt.percent(p.valid_pct)}`).join(', ');
  return (
    <div>
      <div className="flex items-center">
        <div className="text-[0.6875rem] font-semibold uppercase tracking-wider text-gray-500">Month by month</div>
        <InfoTip id="effort.trend" />
      </div>
      <div role="img" aria-label={`Entries with one standard tag by month: ${summary}`}>
        <ol className="mt-2 flex items-end gap-3" aria-hidden>
          {points.map((p) => {
            const on = p.period === current;
            return (
              <li key={p.period} className="flex w-12 flex-col items-center gap-1">
                <span className={`text-xs tabular-nums ${on ? 'font-semibold text-gray-900' : 'text-gray-600'}`}>{fmt.percent(p.valid_pct)}</span>
                <div className="flex h-14 w-full items-end overflow-hidden rounded-md bg-gray-100">
                  <div
                    className={`w-full rounded-md transition-[height] duration-300 ease-out motion-reduce:transition-none ${on ? 'bg-gray-800' : 'bg-gray-500'}`}
                    style={{ height: `${Math.max(p.valid_pct === null ? 0 : 4, p.valid_pct ?? 0)}%` }}
                  />
                </div>
                <span className={`text-xs ${on ? 'font-semibold text-gray-900' : 'text-gray-600'}`}>{fmt.monthAbbr(p.period)}</span>
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
}
